/* RYVOX feel layer (18 Oct 2026). Companion to feel.css; no libraries.
   - names the tapped bike photo so it morphs into the product page
   - counts spec numbers up from zero the first time they come into view
     (the real number is in the HTML; only the drawing animates)
   - section rise and card stagger, armed only after the first scroll
   - cursor light on bike cards (mouse only)
   Reduced motion: only the photo naming runs, and the browser skips the
   morph itself. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html = document.documentElement;

  /* ---- 1. photo morph ---- */
  function clearNames() {
    html.classList.remove('rx-vt-card');
    Array.prototype.forEach.call(document.querySelectorAll('[data-rx-vt]'), function (x) {
      x.style.viewTransitionName = '';
      x.removeAttribute('data-rx-vt');
    });
  }
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a || a.target === '_blank') return;
    var card = a.closest('.bcard, .card, .bhero');
    if (!card) return;
    var img = card.querySelector('.bcard__img, .bhero__img, .card__img, img');
    if (!img) return;
    clearNames();
    html.classList.add('rx-vt-card');
    img.style.viewTransitionName = 'rx-bike';
    img.setAttribute('data-rx-vt', '');
  }, true);
  window.addEventListener('pageshow', clearNames);

  /* ---- 0. desktop product page (18 Oct 2026 QA fix #3) ----
     Wide screens: the floating Add to cart card showed on load, on top of the
     colour and payment buttons it duplicates. feel.css now keeps it hidden on
     900px+ until the product form (the real buttons) has scrolled up under the
     header, which this sets as html.rx-atc-past. Phones keep today's bar.
     The photo column is pinned beside the specs only when photos, thumbnails
     and header all fit the screen, so a short laptop never loses thumbnails.
     Runs with reduced motion too: nothing here animates. */
  (function () {
    if (!window.matchMedia) return;
    var wide = window.matchMedia('(min-width: 900px)');
    var form = document.querySelector('[data-atc-anchor]');
    var bar = document.querySelector('[data-sticky-atc]');
    var media = document.querySelector('.pdp > .pdp__media');
    var head = document.querySelector('.header-wrap');
    if (!(form && bar) && !media) return;
    function sync() {
      var h = head ? head.getBoundingClientRect().height : 72;
      if (form && bar) html.classList.toggle('rx-atc-past', form.getBoundingClientRect().bottom < h);
      if (media) {
        var pin = wide.matches && media.offsetHeight + h + 16 <= window.innerHeight;
        media.classList.toggle('rx-pin', pin);
        media.style.top = pin ? (Math.round(h) + 8) + 'px' : '';
      }
    }
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
    sync();
  })();

  if (reduce || !('IntersectionObserver' in window)) return;

  /* ---- 2. spec count-up ---- */
  function countUp(el) {
    var txt = el.textContent;
    var parts = txt.split(/(\d+(?:\.\d+)?)/);
    if (parts.length < 3) return;
    var nums = [];
    for (var i = 1; i < parts.length; i += 2) nums.push({ i: i, v: parseFloat(parts[i]), d: (parts[i].split('.')[1] || '').length });
    var w = el.getBoundingClientRect().width;
    el.style.display = 'inline-block';
    el.style.minWidth = Math.ceil(w) + 'px';
    var t0 = null, dur = 900;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      var out = parts.slice();
      nums.forEach(function (n) { out[n.i] = (n.v * e).toFixed(n.d); });
      el.textContent = out.join('');
      if (k < 1) requestAnimationFrame(frame);
      else { el.textContent = txt; el.style.minWidth = ''; el.style.display = ''; }
    }
    requestAnimationFrame(frame);
  }
  var countIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      countIO.unobserve(en.target);
      countUp(en.target);
    });
  }, { threshold: 0.6 });
  Array.prototype.forEach.call(document.querySelectorAll('.bhero__spec b, .pdpb__spec b, .bcard__gauge b'), function (b) { countIO.observe(b); });

  /* ---- 3. card stagger ---- */
  Array.prototype.forEach.call(document.querySelectorAll('.lineup__grid, .product-grid'), function (g) {
    var i = 0;
    Array.prototype.forEach.call(g.children, function (c) {
      if (c.classList && c.classList.contains('reveal')) { c.style.setProperty('--rx-d', ((i % 4) * 70) + 'ms'); i++; }
    });
  });

  /* ---- 4. section rise, armed on the first scroll ---- */
  var armed = false;
  function arm() {
    if (armed) return;
    armed = true;
    window.removeEventListener('scroll', arm);
    var vh = window.innerHeight;
    var riseIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        riseIO.unobserve(en.target);
        var s = en.target;
        s.classList.add('rx-in');
        /* Drop the classes once settled, so no transform is left on the
           section (a transformed ancestor would trap fixed bars inside it). */
        setTimeout(function () { s.classList.remove('rx-rise', 'rx-in'); }, 700);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    Array.prototype.forEach.call(document.querySelectorAll('main > .shopify-section'), function (s, idx) {
      if (idx < 1) return;
      if (s.getBoundingClientRect().top < vh * 1.05) return;
      if (s.querySelector('[data-sticky-atc], .sticky-atc, .ctray, [data-compare-tray], .pdp-lb, iframe')) return;
      s.classList.add('rx-rise');
      riseIO.observe(s);
    });
  }
  window.addEventListener('scroll', arm, { passive: true });

  /* ---- 5. cursor light on bike cards (mouse only) ---- */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var pending = null, last = null;
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.bcard');
      if (!card) return;
      last = { c: card, x: e.clientX, y: e.clientY };
      if (pending) return;
      pending = requestAnimationFrame(function () {
        pending = null;
        var r = last.c.getBoundingClientRect();
        last.c.style.setProperty('--mx', (last.x - r.left) + 'px');
        last.c.style.setProperty('--my', (last.y - r.top) + 'px');
      });
    }, { passive: true });
  }
})();
